export const ModalResetPasswordTranslationsEn = {
  resetPassword: 'Reset password',
  Email: 'Email',
  saveButton: 'Save',
  enterYourEmail: 'Enter your Email',
};
